import React, { useCallback, useEffect, useRef, useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import GetAppIcon from "@mui/icons-material/GetApp";
import AddIcon from "@mui/icons-material/Add";
import { useHistory } from "react-router-dom";
import { onHomeDashClientes } from "../Dashboard/Clientes/CapturasDashClientes/onOpenScreenDashCliente";

// Plantilla base de pantallas (reutilizable).
// Acciones opcionales del header (solo se muestran si se pasan):
// - filtro: ({ cerrar }) => <FiltroPanel .../>  → botón "Filtrar" + panel flotante
// - filtrosActivos: número para el indicador del botón "Filtrar"
// - onAgregar / agregarTexto / agregarDeshabilitado → botón "Agregar" a la derecha
// - onExcel / excelDeshabilitado → botón "Excel" a la derecha
// - accionesDerecha: nodos extra a la derecha (antes del Excel)
// - mostrarRegresar: false oculta el botón "Regresar" (por defecto siempre se muestra). Pensado
//   para las pantallas principales de módulo, que no tienen a dónde regresar.
// La plantilla no conoce endpoints: cada pantalla decide qué hace cada acción.
// Actualizado: 2026-09-17 — IA (Claude): el módulo se muestra debajo del título.
const PlantillaScreenRemastered = ({
  modulo,
  titulo,
  children,
  className,
  onRegresar,
  idcliente,
  filtro,
  filtrosActivos = 0,
  onExcel,
  excelDeshabilitado = false,
  onAgregar,
  agregarTexto = "Agregar",
  agregarDeshabilitado = false,
  accionesDerecha,
  mostrarRegresar = true,
}) => {
  const history = useHistory();
  const [filtroAbierto, setFiltroAbierto] = useState(false);
  const filtroRef = useRef(null);

  const handleRegresar = () => {
    if (onRegresar) return onRegresar();
    onHomeDashClientes();
    history.push("/DashClientes/Main", { idcliente });
  };

  const cerrarFiltro = useCallback(() => setFiltroAbierto(false), []);

  // Cierra el panel con clic fuera o con Esc.
  useEffect(() => {
    if (!filtroAbierto) return undefined;
    const onClickFuera = (e) => {
      if (filtroRef.current && !filtroRef.current.contains(e.target)) cerrarFiltro();
    };
    const onEsc = (e) => e.key === "Escape" && cerrarFiltro();
    document.addEventListener("mousedown", onClickFuera);
    document.addEventListener("keydown", onEsc);
    return () => {
      document.removeEventListener("mousedown", onClickFuera);
      document.removeEventListener("keydown", onEsc);
    };
  }, [filtroAbierto, cerrarFiltro]);

  const tieneDerecha = Boolean(onAgregar || onExcel || accionesDerecha);

  return (
    <div className={`plantilla-screen-remastered ${className || ""}`}>
      <div className="plantilla-screen-remastered-header">
        <div className="plantilla-screen-remastered-acciones izquierda">
          {mostrarRegresar && (
            <button
              className="plantilla-screen-remastered-back"
              aria-label="Regresar"
              onClick={handleRegresar}
            >
              <ArrowBackIcon />
            </button>
          )}

          {filtro && (
            <div className="psr-filtro" ref={filtroRef}>
              <button
                type="button"
                className={`psr-btn psr-btn-filtro ${filtroAbierto ? "activo" : ""}`}
                aria-expanded={filtroAbierto}
                onClick={() => setFiltroAbierto((prev) => !prev)}
              >
                <FilterAltIcon /> <span className="psr-btn-label">Filtrar</span>
                {filtrosActivos > 0 && <span className="psr-btn-badge">{filtrosActivos}</span>}
              </button>
              {filtroAbierto && <div className="psr-filtro-popover">{filtro({ cerrar: cerrarFiltro })}</div>}
            </div>
          )}
        </div>

        <div className="plantilla-screen-remastered-titulo">
          <span className="plantilla-screen-remastered-nombre">{titulo}</span>
          <span className="plantilla-screen-remastered-modulo">{modulo}</span>
        </div>

        {tieneDerecha && (
          <div className="plantilla-screen-remastered-acciones derecha">
            {accionesDerecha}
            {onAgregar && (
              <button
                type="button"
                className="psr-btn psr-btn-agregar"
                onClick={onAgregar}
                disabled={agregarDeshabilitado}
              >
                <AddIcon /> <span className="psr-btn-label">{agregarTexto}</span>
              </button>
            )}
            {onExcel && (
              <button
                type="button"
                className="psr-btn psr-btn-excel"
                onClick={onExcel}
                disabled={excelDeshabilitado}
              >
                <GetAppIcon /> <span className="psr-btn-label">Excel</span>
              </button>
            )}
          </div>
        )}
      </div>
      <div className="plantilla-screen-remastered-linea" />
      <div className="plantilla-screen-remastered-container scroll">
        {children}
      </div>
    </div>
  );
};

export default PlantillaScreenRemastered;
